export default "__VITE_ASSET__c1e1ff55__"